import { createCookie, eraseCookie } from "../../utils";
import { blackboltConfig } from "../../constants";

const createCookies = (...cookies) => {
  cookies.forEach(cookie => {
    const [username] = Object.getOwnPropertyNames(cookie);
    createCookie(username, cookie[username]);
  });
};

// Login methods goes here
const formatLoginQuery = (username, password) =>
  JSON.stringify({
    grant_type: blackboltConfig.grant_type,
    username,
    password,
  });
const decodeToken = token => {
  let tokenString = token;
  tokenString = tokenString.split(".");
  let [, str] = tokenString;
  str = str.replace("/-/g", "+");
  str = str.replace("/_/g", "/");
  switch (str.length % 4) {
    case 0:
      break;
    case 2:
      str += "==";
      break;
    case 3:
      str += "=";
      break;
    default: {
      const err = "Invalid token";
      throw err;
    }
  }
  // eslint-disable-next-line
  str = (str + "===").slice(0, str.length + str.length % 4);
  str = str.replace(/-/g, "+").replace(/_/g, "/");

  str = decodeURIComponent(escape(atob(str)));

  str = JSON.parse(str);
  return str;
};
const formatResetPasswordQuery = (id, type) => {
  const headers = {
    "X-Channel": blackboltConfig.channel,
    "X-Communication-Type": type,
  };
  const body = JSON.stringify({
    username: id,
  });
  return {
    headers,
    body,
  }
};

function setTokens({ access_token: accessToken, refresh_token: refreshToken }) {
  createCookies({ accessToken }, { refreshToken });
}
const deleteCookies = (...cookies) => {
  cookies.forEach(val => {
    eraseCookie(val);
  });
};

// Register methods goes here
const formatSocialQuery = userData => {
  const {
    email = null,
    emailId = null,
    mobileNo = null,
    mobileNumber = null,
    source,
    socialToken,
  } = userData;
  // TODO pick template from separate file
  const userDetails = {
    emailId : email || emailId,
    mobileNumber: mobileNo || mobileNumber,
    userType: "SOCIAL_USER",
    socialIdentityProvider: source,
    socialToken,
  };
  return JSON.stringify(userDetails);
};

const formatRegisterQuery = ({
  password,
  email: emailId,
  name: firstName,
  mobileNo: mobileNumber,
}) => {
  const userDetails = {
    emailId,
    firstName,
    mobileNumber,
    password,
    userType: 'END_USER',
  }
  return JSON.stringify(userDetails);
};


export {
  decodeToken,
  formatLoginQuery,
  formatRegisterQuery,
  formatSocialQuery,
  formatResetPasswordQuery,
  setTokens,
  deleteCookies,
  createCookies,
};



// WEBPACK FOOTER //
// ./src/stores/Login/loginStore.methods.js